const baseWalletsApiPath = 'organizations/:organizationId/wallets';
const baseConversionsApiPath = 'organizations/:organizationId/conversions';

export const walletsApiPaths = <const>{
    wallets: baseWalletsApiPath,
    wallet: `${baseWalletsApiPath}/:walletId`,
    walletsBalances: `${baseWalletsApiPath}/balances`,
    fundingAccounts: `${baseWalletsApiPath}/:walletId/funding-accounts`,
    transactions: `${baseWalletsApiPath}/transactions`,
    visibility: `${baseWalletsApiPath}/visibility`,
    conversions: baseConversionsApiPath,
    quotes: `${baseConversionsApiPath}/quotes`,
};
